
import DatePicker from "@/components/DatePicker.vue";
import Vue, { PropType } from "vue";

let timedOutFunctionDate: any;
let timedOutFunctionTime: any;

// eslint-disable-next-line
const datePicker: any = Vue.extend({
  props: {
    value: {
      type: Date as PropType<Date | null>,
    },
    label: {
      type: String,
      default: "Datum",
    },
    labelTime: {
      type: String,
      default: "Uhrzeit",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultHour: {
      type: Number,
    },
    prependIcon: {
      type: String,
    },
  },
  data() {
    return {
      valueDateAsStr: "",
      valueTimeAsStr: "",
      rulesDate: [
        (v: string) =>
          (v &&
            /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
              v
            )) ||
          "Eingabe ist kein valides Datum",
      ],
      rulesTime: [(v: string) => (v && v.length <= 2) || "Eingabe ist zu kurz"],
      labelTimeErrorMessage: null as string | null,
    };
  },
  computed: {
    formattedDateValue: {
      get(): string {
        return this.valueDateAsStr;
      },
      set(val: string) {
        if (timedOutFunctionDate) {
          clearTimeout(timedOutFunctionDate);
        }
        timedOutFunctionDate = setTimeout(() => {
          if (!val) {
            this.$emit("input", null);
          }
          if (
            val.lastIndexOf(".") > -1 &&
            val.substr(val.lastIndexOf(".") + 1).length === 4
          ) {
            let [day, month, year] = val.split(".");
            if (year.length === 2) {
              year = 20 + year;
            }
            let newDate = new Date(
              `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
            );
            if (this.defaultHour) {
              newDate.setHours(this.defaultHour);
            }
            this.$emit("input", newDate);
          }
          if (val.length === 2 && !val.endsWith(".")) {
            val = val + ".";
          } else if (
            val.length === 5 &&
            !val.endsWith(".") &&
            val.lastIndexOf(".") !== 3
          ) {
            val = val + ".";
          }
          if (val.length <= 10) {
            this.valueDateAsStr = val;
          }
          this.emitAsDate();
        }, 200);
      },
    },
    formattedTimeValue: {
      get(): string {
        return this.valueTimeAsStr;
      },
      set(val: string) {
        if (timedOutFunctionTime) {
          clearTimeout(timedOutFunctionTime);
        }
        this.labelTimeErrorMessage = null;
        timedOutFunctionTime = setTimeout(() => {
          if (val && val.length > 1 && val.indexOf(":") === -1) {
            val = val + ":";
          }
          if (+val.split(":")[0] > 23) {
            this.labelTimeErrorMessage = "Falsche Stundenangabe";
            return;
          }
          if (+val.split(":")[1] > 59) {
            this.labelTimeErrorMessage = "Falsche Minutenangabe";
            return;
          }
          this.valueTimeAsStr = val;
          if (this.valueTimeAsStr && this.valueTimeAsStr.length > 4) {
            this.labelTimeErrorMessage = null;
            this.emitAsDate();
          }
        }, 200);
      },
    },
    formattedValueForCalendar: {
      get(): string {
        try {
          if (this.value) {
            return this.value.toISOString().substr(0, 10);
          } else {
            return "";
          }
        } catch (e) {
          return "";
        }
      },
      set(val: string) {
        const [year, month, day] = val.split("-");
        this.valueDateAsStr = day + "." + month + "." + year;
        const newDate = new Date(val);
        if (this.defaultHour) {
          newDate.setHours(this.defaultHour);
        }
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        this.$emit("input", newDate);
        this.emitAsDate();
      },
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value instanceof Date && !isNaN(this.value.getTime())) {
          console.log("this is my input?", this.value)
          const [year, month, day] = this.value
            .toISOString()
            .substr(0, 10)
            .split("-");
          this.valueDateAsStr = `${day}.${month}.${year}`;
          const [hours, minutes] = this.value
            .toLocaleTimeString()
            .substr(0, 5)
            .split(":");
          this.valueTimeAsStr = `${hours}:${minutes}`;
        } else {
          this.valueDateAsStr = "";
          this.valueTimeAsStr = "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    emitAsDate() {
      const [day, month, year] = this.valueDateAsStr.split(".");
      if (
        year &&
        month &&
        day &&
        day !== "0" &&
        month !== "0" &&
        year.length >= 2
      ) {
        let yearModified = year.length == 2 ? "20" + year : year;
        let dateTime = new Date(`${yearModified}-${month}-${day}`);
        if (
          this.valueTimeAsStr &&
          this.valueTimeAsStr.length > 2 &&
          this.valueTimeAsStr.toString().indexOf(":") > -1
        ) {
          const [hours, minutes] = this.valueTimeAsStr.split(":");
          if (hours && minutes && minutes !== "0") {
            dateTime.setHours(parseInt(hours), parseInt(minutes));
          }
        } else if (this.defaultHour) {
          dateTime.setHours(this.defaultHour);
        }
        dateTime.setSeconds(0);
        dateTime.setMilliseconds(0);
        console.log("hier emitAsDate", dateTime);
        this.$emit("input", dateTime);
        this.$emit("change");
      }
    },
  },
  components: {
    DatePicker,
  },
});

export default datePicker;
